import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/parse/index.js';

var require$$57 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$57 as default };
